import ShoppingCoupons from '../schema/ShoppingCoupons';
import { SHOPPING_COUPONS as shoppingCouponsTypes } from '../mutation-types';

//Actions
const actions = {
  insert({
    commit
  }, payload) {
    commit(shoppingCouponsTypes.UPSERT, payload);
  }
};

// Mutations
const mutations = {
  [shoppingCouponsTypes.UPSERT](state, payload) {
    ShoppingCoupons.update({
      _id: payload._id
    }, payload, {
      upsert: true
    });
  }
};

export default {
  namespaced: true,
  state: ShoppingCoupons.state,
  getters: ShoppingCoupons.getters,
  actions,
  mutations
};
